import { Component, ElementRef, Output, ViewChild, EventEmitter, AfterViewInit, Input } from '@angular/core';
import { Platform } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-bottom-drawer',
  templateUrl: './bottom-drawer.component.html',
  styleUrls: ['./bottom-drawer.component.scss'],
})
export class BottomDrawerComponent implements AfterViewInit {
  @ViewChild('bottomDrawer', { read: ElementRef }) bottomDrawer: ElementRef;
  @ViewChild('bottomDrawerContent', { read: ElementRef }) bottomDrawerContent: ElementRef;

  @Output('onStateChange') openState: EventEmitter<boolean> = new EventEmitter();
  @Output('onClosedByUser') closedByUser: EventEmitter<void> = new EventEmitter();
  @Input('maxHeight') maxHeight: number;
  @Input('maxHeightPercentage') maxHeightPerc: number;
  @Input('widthPercentage') widthPercentage: number;
  @Input('topOffset') topOffset: number; // in pixels
  @Input('bottomOffset') bottomOffset: number; // in pixels
  @Input('showCloseButton') showCloseButton: boolean = true;

  private isOpen: boolean = false;
  private openHeight: number;
  private transitionTime: number = 0.4; // in seconds
  private transitionTimer = null;

  constructor(
    private plt: Platform,
    private log: NGXLogger
  ) {}

  async ngAfterViewInit() {
    this.recomputeHeight();

    const width = this.plt.width;

    const drawerContent = this.bottomDrawerContent.nativeElement;
    drawerContent.style.width = width + 'px';
    drawerContent.style.height = this.openHeight + 'px';

    // corret the position with bottomOffset
    if (this.bottomOffset) {
      const drawer = this.bottomDrawer.nativeElement;
      const newBottom = -this.plt.height() + this.bottomOffset;
      drawer.style.bottom = newBottom + 'px';
    }
  }

  toggleDrawer(isClosedByUser?: boolean) {
    this.log.debug('isOpen', this.isOpen);
    if (!isClosedByUser) {
      isClosedByUser = false;
    }
    // compute maxHeight in case it changed
    this.recomputeHeight();
    const drawerContent = this.bottomDrawerContent.nativeElement;
    drawerContent.style.height = this.openHeight + 'px';

    // positions drawer relative to view height
    const drawer = this.bottomDrawer.nativeElement;

    if (this.isOpen) {
      // close drawer
      drawer.style.transition = this.transitionTime + 's ease-in';
      drawer.style.transform = '';
      this.isOpen = false;
      this.triggerOpenStateAfterTransition(isClosedByUser);
    } else {
      // open drawer
      drawer.style.transition = this.transitionTime + 's ease-out';
      drawer.style.transform = 'translateY(' + -this.openHeight + 'px)';
      this.isOpen = true;
      this.triggerOpenStateAfterTransition();
    }
  }

  onCloseClick() {
    if (this.isOpen) {
      this.toggleDrawer(true);
    }
  }

  private recomputeHeight() {
    let viewHeight = this.plt.height();
    if (this.bottomOffset) {
      viewHeight -= this.bottomOffset;
    }
    if (this.topOffset) {
      viewHeight -= this.topOffset;
    }
    if (!this.maxHeight && !this.maxHeightPerc) {
      this.openHeight = (viewHeight / 100) * 33.3;
    } else if (this.maxHeightPerc) {
      this.openHeight = (viewHeight / 100) * this.maxHeightPerc;
    } else {
      this.openHeight = this.maxHeight;
    }
  }

  private triggerOpenStateAfterTransition(isClosedByUser?: boolean) {
    this.cancelTransitionTrigger();
    this.transitionTimer = setTimeout(() => {
      this.openState.emit(this.isOpen);
      if (isClosedByUser) {
        this.closedByUser.emit();
      }
    }, this.transitionTime * 1000);
  }

  private cancelTransitionTrigger() {
    if (this.transitionTimer) {
      clearTimeout(this.transitionTimer);
    }
  }
}
